<template>
    <!-- 提交申请 -->
    <div class="wid-100">
        <!--  v-show="$route.meta.showFather" -->
        <div class="" style="">
            <div class="box-shadow pad-16 mb-16">
                <el-form ref="form" :model="form" class="boc-form" label-width="80px">
                    <el-form-item label="发票类型">
                        <el-input v-model="form.invoiceType" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="抬头类型">
                        <el-input v-model="form.headingType==1?'个人非企业':'企业'" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="发票抬头">
                        <el-input v-model="form.invoiceHeading" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="企业税号" v-if="status==2">
                        <el-input v-model="form.enterpriseTaxNo" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="企业地址" v-if="status==2">
                        <el-input v-model="form.enterpriseAddress" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="企业电话" v-if="status==2">
                        <el-input v-model="form.enterpriseMobile" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" v-if="status==2">
                        <el-input v-model="form.bankName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input v-model="form.mobile" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱">
                        <el-input v-model="form.email" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="邮寄地址">
                        <el-input v-model="form.mailAddress" disabled></el-input>
                    </el-form-item>
                </el-form>
                <div class="flex-1 jus-bet">
                    <div></div>
                    <div>
                        <el-button @click="edit(form)">返回修改</el-button>
                        <el-button type="primary" @click="submit">提交申请</el-button>
                    </div>
                    
                    <div></div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {
        getApply
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                form: {
                    amount: '',
                    levelOrderIds: [],
                    activityOrderIds: [],
                    headingType: '1',
                    invoiceType: '增值税电子普通发票',
                    invoiceHeading: '',
                    enterpriseTaxNo: '',
                    enterpriseAddress: '',
                    enterpriseMobile: '',
                    bankName: '',
                    mobile: '',
                    email: '',
                    mailAddress: '',
                },
                status:''
            }

        },
        created() {},
        mounted() {
            // this.status = this.$route.params.resource;
            // console.log(this.status,'this.status')
            console.log(this.$route.params,'this.status')
            this.form = this.$route.params;
            this.status = this.$route.params.headingType;
        },
        methods: {
            edit(form){
                // this.$router.back()
                this.$router.push({
                    name:'/invoice/inInformation',
                    params:{
                        form:JSON.stringify(form),
                        types:3
                    }
                })
            },
            submit(){
                let params = this.form;
                getApply(params).then(res => {
                        if (res.code == 0) {
                            this.$message.success('提交成功');
                            // 跳转我的发票
                            this.$router.push('/personal/service/invoice/myInvoice')
                        }
                    })
                    .catch(error => {
                
                    });
            }
        }
    }
</script>

<style>

</style>
<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-36 {
        padding: 36px 16px 51px 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .status {

        border-radius: 8px 8px 0 0;
        padding: 6px 0 5px 16px;
    }

    .status span {
        padding-right: 16px;
    }

    .tiantou {
        color: #999999;
        padding-right: 16px;
    }

    .money {
        color: #FFBA31;
    }

    .font-1 {
        font-size: 14px;
        line-height: 21px;
    }

    .names {
        color: #222222;
    }

    .details {
        color: #333333;
        padding-right: 8px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .col-1 {
        color: #3ECC64;
        background-color: #EBFAEF;
    }

    .col-2 {
        color: #FF534D;
        background-color: #FFF0F0;
    }

    .col-3 {
        color: #FBB54C;
        background-color: #FFF6F0;
    }

    .pad-16 {
        padding: 16px;
    }

    .experts {
        font-size: 20px;
        color: #222222;
        padding-left: 10px;
    }

    .money-1 {
       
    }

    .c-iocn {
        color: #999999;
        font-size: 14px;
        font-weight: 800;
    }

    .mb-55 {
        margin-bottom: 55px;
    }

    .w-25 {
        width: 32%;
        white-space: nowrap;
    }

    .w-25 .names {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .el-button--primary {
        background-color: #3377FF;
        border: 0;
    }
    .el-button--default{
        background-color: #F0F5FF;
        border: 0;
    }
   /deep/.el-button--default span{
        font-size: 16px;
        color: #3377FF;
        text-align: center;
    }

    /deep/.el-button--primary span {
        font-size: 16px;
        color: #ffffff;
        text-align: center;
    }

    .boc-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .boc-form .el-form-item {
        width: 41%;
    }

    /deep/.boc-form .el-form-item__label {
        padding-right: 16px;
        color: #222222;
        font-size: 14px;
    }

    /deep/.el-radio__input.is-checked .el-radio__inner::after {
        border: 3px solid #ffffff;
        width: 5px;
        height: 7px;
        border-left: 0;
        border-top: 0;
        border-bottom: 3px solid #ffffff;
        top: 0;
        left: 2px;
        transform: rotate(45deg) scaleY(1.1);
        background: none;
        border-radius: 0px;


        /*      box-sizing: content-box;
            content: "";
            border: 1px solid #FFF;
            border-left: 0;
            border-top: 0;
            height: 0;
            left: 0;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(0);
            width: 3px;
            transition: transform .15s ease-in .05s;
            transform-origin: center; */
    }

    /deep/.el-radio__input.is-checked .el-radio__inner {
        background-color: #3377FF;
    }

    /deep/.el-radio__input.is-checked+.el-radio__label {
        color: #3377FF;
    }

    /deep/.el-input.is-disabled .el-input__inner {
        background-color: #EFEFEF;
        color: #222222;
        font-size: 14px;

    }

    /deep/.el-input__inner {
        color: #222222;
        font-size: 14px;
    }
</style>
